module.exports = __webpack_public_path__ + "static/media/03 Generali Gospodarstwo Rolne Ustandaryzowany dokument.8901fbf6.pdf";